/* ============================================================
   MEHERVA — Theme JavaScript v4 (Production)
   ============================================================ */
(function () {
  'use strict';

  // ---- Scroll reveal ----
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length || !window.IntersectionObserver) {
      els.forEach(function(el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { io.observe(el); });
  }

  // ---- Mobile menu ----
  function initMobileMenu() {
    var burger = document.getElementById('nav-burger');
    var menu = document.getElementById('mobile-menu');
    var close = document.getElementById('mobile-menu-close');
    if (!burger || !menu) return;
    burger.addEventListener('click', function() {
      menu.classList.add('open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    function closeMenu() {
      menu.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (close) close.addEventListener('click', closeMenu);
    menu.addEventListener('click', function(e) { if (e.target === menu) closeMenu(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') { closeMenu(); closeCart(); } });
  }

  // ---- Cart open/close ----
  function openCart() {
    var overlay = document.getElementById('cart-overlay');
    var drawer = document.getElementById('cart-drawer');
    if (!overlay || !drawer) return;
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    var overlay = document.getElementById('cart-overlay');
    var drawer = document.getElementById('cart-drawer');
    if (!overlay || !drawer) return;
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ---- Toast notification ----
  function showToast(message) {
    var existing = document.getElementById('meherva-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'meherva-toast';
    toast.textContent = message;
    toast.style.cssText = [
      'position:fixed',
      'top:90px',
      'left:50%',
      'transform:translateX(-50%)',
      'background:linear-gradient(135deg,#F0CE7E,#D4AF37)',
      'color:#0A0605',
      'padding:14px 32px',
      'font-family:Jost,sans-serif',
      'font-size:12.5px',
      'letter-spacing:0.18em',
      'border-radius:2px',
      'z-index:9999',
      'box-shadow:0 8px 30px rgba(212,175,55,0.4)',
      'opacity:0',
      'transition:opacity 0.3s ease',
      'white-space:nowrap'
    ].join(';');

    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      toast.style.opacity = '1';
      setTimeout(function() {
        toast.style.opacity = '0';
        setTimeout(function() { if (toast.parentNode) toast.remove(); }, 350);
      }, 2500);
    });
  }

  // ---- Load cart contents ----
  function loadCartContents(openAfterLoad) {
    var cartItemsEl = document.getElementById('cart-items');
    var cartSubtotalEl = document.getElementById('cart-subtotal');

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Update badge
        var badge = document.getElementById('cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }

        // Update subtotal
        if (cartSubtotalEl) {
          var total = (cart.total_price / 100);
          cartSubtotalEl.textContent = 'Rs. ' + total.toLocaleString('en-PK', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }

        // Render items
        if (cartItemsEl) {
          if (cart.item_count === 0) {
            cartItemsEl.innerHTML = '<div class="cart-empty"><div class="urdu">م</div><p>Your bag is empty</p><a href="/collections/all" class="btn btn-outline" style="margin-top:20px;display:inline-flex;">SHOP NOW</a></div>';
          } else {
            var html = '';
            cart.items.forEach(function(item) {
              var linePrice = (item.line_price / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 });
              html += '<div style="display:flex;gap:14px;padding:18px 0;border-bottom:1px solid var(--line);">';
              if (item.image) {
                html += '<a href="' + item.url + '" style="flex-shrink:0;"><img src="' + item.image + '" alt="' + item.product_title + '" style="width:70px;height:93px;object-fit:cover;border-radius:2px;border:1px solid var(--line);"></a>';
              }
              html += '<div style="flex:1;min-width:0;">';
              html += '<p style="font-size:13px;color:var(--cream);margin-bottom:4px;font-family:Cormorant Garamond,serif;line-height:1.3;">' + item.product_title + '</p>';
              if (item.variant_title && item.variant_title !== 'Default Title') {
                html += '<p style="font-size:11.5px;color:var(--cream-dim);margin-bottom:6px;">' + item.variant_title + '</p>';
              }
              html += '<p style="font-size:14px;color:var(--gold-light);margin-bottom:10px;">Rs. ' + linePrice + '</p>';
              html += '<div style="display:flex;align-items:center;gap:14px;">';
              html += '<div style="display:flex;align-items:center;border:1px solid var(--line);">';
              html += '<a href="/cart/change?id=' + item.key + '&quantity=' + Math.max(0, item.quantity - 1) + '" style="width:30px;height:30px;display:flex;align-items:center;justify-content:center;color:var(--gold-light);font-size:14px;text-decoration:none;">−</a>';
              html += '<span style="width:30px;text-align:center;font-size:13px;color:var(--cream);">' + item.quantity + '</span>';
              html += '<a href="/cart/change?id=' + item.key + '&quantity=' + (item.quantity + 1) + '" style="width:30px;height:30px;display:flex;align-items:center;justify-content:center;color:var(--gold-light);font-size:14px;text-decoration:none;">+</a>';
              html += '</div>';
              html += '<a href="/cart/change?id=' + item.key + '&quantity=0" style="font-size:11px;color:var(--cream-dim);border-bottom:1px solid var(--line);text-decoration:none;">Remove</a>';
              html += '</div></div></div>';
            });
            cartItemsEl.innerHTML = html;
          }
        }

        if (openAfterLoad) openCart();
      })
      .catch(function() {
        if (openAfterLoad) openCart();
      });
  }

  // ---- Cart init ----
  function initCart() {
    var overlay = document.getElementById('cart-overlay');
    var closeBtn = document.getElementById('cart-close');
    var cartBtns = document.querySelectorAll('[data-cart-open]');

    cartBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        loadCartContents(true);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);
  }

  // ---- Accordion ----
  function initAccordion() {
    document.addEventListener('click', function(e) {
      var head = e.target.closest('.acc-head');
      if (!head) return;
      var item = head.parentElement;
      var isOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.acc-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  }

  // ---- Sticky header ----
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          header.style.boxShadow = window.scrollY > 40 ? '0 4px 30px rgba(0,0,0,0.5)' : 'none';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ---- Quick add from product grid ----
  function initQuickAdd() {
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('.quick-add-form');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.quick-add');
      var original = btn ? btn.textContent : '';
      if (btn) btn.textContent = '✓';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        showToast('✓  ' + item.product_title + ' added to bag');
        if (btn) btn.textContent = original;
        loadCartContents(false); // update badge silently
        setTimeout(function() { loadCartContents(true); }, 400); // open drawer with item
      })
      .catch(function() { if (btn) btn.textContent = original; });
    });
  }

  // ---- Product page add to cart (called inline from product.liquid) ----
  window.mehervaAddToCart = function(formEl, btnEl) {
    var original = btnEl.textContent;
    btnEl.textContent = 'ADDING...';
    btnEl.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(formEl),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      btnEl.textContent = 'ADDED ✓';
      showToast('✓  ' + item.product_title + ' added to bag');
      loadCartContents(false); // update badge
      setTimeout(function() {
        btnEl.textContent = original;
        btnEl.disabled = false;
        loadCartContents(true); // open drawer with product inside
      }, 800);
    })
    .catch(function() {
      btnEl.textContent = original;
      btnEl.disabled = false;
    });
  };

  // ---- Cart count on load ----
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badge = document.getElementById('cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(function() {});
  }

  document.addEventListener('DOMContentLoaded', function() {
    initReveal();
    initMobileMenu();
    initCart();
    initAccordion();
    initHeaderScroll();
    initQuickAdd();
    updateCartCount();
  });

})();
